import { useTranslation } from 'react-i18next'

import { Button } from '@/components/v2/ui'
import { EID } from '@/lib/element-ids.registry'

/** Supported Amazon market TLDs — sourced from app.core.listing_builder.knowledge.marketplace.MARKETPLACE_LIMITS */
const TLDS = [
  { tld: 'de', label: 'amazon.de' },
  { tld: 'com', label: 'amazon.com' },
  { tld: 'co.uk', label: 'amazon.co.uk' },
  { tld: 'fr', label: 'amazon.fr' },
  { tld: 'it', label: 'amazon.it' },
  { tld: 'es', label: 'amazon.es' },
] as const

export function MarketTldSelector({
  value,
  onChange,
}: {
  value: string
  onChange: (tld: string) => void
}) {
  const { t } = useTranslation()
  return (
    <div
      className="listing-builder-tld-chips flex flex-wrap gap-2"
      role="group"
      aria-label={t('listingBuilder.marketTldLabel')}
    >
      {TLDS.map((m) => (
        <Button
          key={m.tld}
          id={`${EID['listing-builder-market-tld-select']}-${m.tld}`}
          type="button"
          variant={value === m.tld ? 'primary' : 'outline'}
          aria-pressed={value === m.tld}
          onClick={() => onChange(m.tld)}
        >
          {m.label}
        </Button>
      ))}
    </div>
  )
}
